"use client";

import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import hasFadeAnim from "@/lib/animation/hasFadeAnim";
import hasCharAnim from "@/lib/animation/hasCharAnim";

type Props = {
  about_title_html: string;
  about_desc_html: string;
};

const DesignAbout = ({ about_title_html, about_desc_html }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null!);

  useGSAP(
    () => {
      hasFadeAnim();
      hasCharAnim();
    },
    { scope: containerRef },
  );
  return (
    <section ref={containerRef}>
      <div className="inner-container">
        <div className="section-spacing-top">
          <div
            className="ml-0 sm:ml-[30%] md:ml-[38%] lg:ml-[44%] xl:ml-[50%] has_fade_anim"
            data-fade-from="top"
            data-delay="0.15"
            data-duration="0.30"
          >
            <p
              className="text-[17px] sm:text-[22px] lg:text-[28px] xl:text-[32px] leading-relaxed text-black-3"
              dangerouslySetInnerHTML={{ __html: about_title_html }}
            />
            <p
              className="text-[24px] sm:text-[32px] lg:text-[36px] xl:text-[42px] leading-relaxed font-superclarendon font-light mt-8 xl:mt-12 text-black-3 has_char_anim"
              data-delay="0.20"
              data-duration="0.70"
              data-stagger="0.020"
              dangerouslySetInnerHTML={{ __html: about_desc_html }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesignAbout;
